



































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import { Watch } from 'vue-property-decorator'
import { EResidentStatus, IFacility } from '@zunta/configurations'
import TimelineBar from '@/views/app/management/collections/components/GlobalAging/TimelineBar.vue'
import FilterOptions from '@/views/app/management/collections/components/GlobalAging/FilterOptions.vue'
import FilterTag from '@/views/app/management/collections/components/GlobalAging/FilterTag.vue'
import Modal from '@/components/Modal.vue'
import PayersFilterForm from '@/views/app/management/collections/components/GlobalAging/PayersFilterForm.vue'
import ResidentFilterForm from '@/views/app/management/collections/components/GlobalAging/ResidentFilterForm.vue'
import StatusFilterForm from '@/views/app/management/collections/components/GlobalAging/StatusFilterForm.vue'
import FacilityFilterForm from '@/views/app/management/collections/components/GlobalAging/FacilityFilterForm.vue'
import BalanceInPeriodFilterForm
  from '@/views/app/management/collections/components/GlobalAging/BalanceInPeriodFilterForm.vue'

// @ts-ignore
import VueAutoVirtualScrollList from 'vue-auto-virtual-scroll-list'
import CollectionsLineItemsModal from '@/views/app/management/collections/components/CollectionsLineItemsModal.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ZeroBalanceFilterForm from '@/views/app/management/collections/components/GlobalAging/ZeroBalanceForm.vue'
import ResidentCollectionHistoryModal
  from '@/views/app/management/collections/components/GlobalAging/ResidentCollectionHistoryModal.vue'
import ScheduleCallModal from '@/views/app/management/collections/components/GlobalAging/ScheduleCallModal.vue'
import Select from '@/components/Select.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import Card from '@/components/Card.vue'

@Component({
  components: {
    Card,
    Select,
    ScheduleCallModal,
    ResidentCollectionHistoryModal,
    Checkbox,
    CollectionsLineItemsModal,
    FacilityFilterForm,
    StatusFilterForm,
    ResidentFilterForm,
    PayersFilterForm,
    BalanceInPeriodFilterForm,
    ZeroBalanceFilterForm,
    Modal,
    FilterTag,
    FilterOptions,
    TimelineBar,
    Icon,
    // @ts-ignore
    VueAutoVirtualScrollList
  }
})
export default class CollectionsAging extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EResidentStatus = EResidentStatus
  timebarSyncKey: number = 1
  currentFirstItemIndex: number = 0
  amountOfElementsToDisplay: number = 0
  virtualContainerHeight: number = 0
  elementWidth: number = 150
  showFilterOptionModal: boolean = false
  showLineItemsModal: boolean = false
  showScheduleCallModal: boolean = false
  showHistoryModal: boolean = false
  selectedSortOption: string = 'balance'
  selectedFilterOption: string = ''
  submittedFilters: any = {}
  modalComponent: string = ''
  selectedResident: number | string = ''
  filterOptionsList: any[] = [
    {
      label: 'Residents',
      value: 'ResidentFilterForm'
    },
    {
      label: 'Resident Statuses',
      value: 'StatusFilterForm'
    },
    // {
    //   label: 'Facilities',
    //   value: 'FacilityFilterForm'
    // },
    {
      label: 'Payers',
      value: 'PayersFilterForm'
    },
    // {
    //   label: 'Zero balances',
    //   value: 'ZeroBalanceFilterForm'
    // },
    {
      label: 'Balance in period',
      value: 'BalanceInPeriodFilterForm'
    }
  ]
  sortOptionsList: any = {
    balance: {
      label: 'Balance',
      value: 'balance'
    },
    resident: {
      label: 'Resident Name',
      value: 'resident'
    },
    status: {
      label: 'Resident Status',
      value: 'status'
    }
  }
  filterLabelMap: any = {
    residents: {
      label: 'Resident:'
    },
    status: {
      label: 'Status:'
    },
    facilities: {
      label: 'Facility:'
    },
    payers: {
      label: 'Payer:'
    },
    excludeZeroBalances: {
      label: 'Zero balances:'
    },
    period: {
      label: 'Balance in period:'
    }
  }
  filters: any = {
    skip: 0,
    limit: 10000,
    excludeZeroBalances: true,
    sort: 'balance'
  }
  selectedTED: any = {
    remainingAmount: 0,
    billedAmount: 0,
    paidAmount: 0
  }
  selectedFacility: any = null
  facilityOptions: any [] = []

  get dynamicProps () {
    return { facilities: [this.selectedFacility] }
  }

  get transactionLineItems () {
    return this.$store.state.transactions.transactionLineItems
  }

  get filtersMap () {
    return this.$store.state.resident.collectionTasksWithAgingFilters
  }

  get collectionTasksWithAgingItems () {
    return this.$store.state.resident.collectionTasksWithAgingItems
  }

  get intervalTED () {
    return this.$store.state.resident.agingTransactionEffectiveDates
  }

  get intervalTEDSliced () {
    if (!this.intervalTED || !this.intervalTED.length) {
      return []
    }
    return this.intervalTED.slice(this.currentFirstItemIndex, this.amountOfElementsToDisplay + this.currentFirstItemIndex)
  }

  get ableToScroll () {
    return this.intervalTED && this.collectionTasksWithAgingItems && this.collectionTasksWithAgingItems.length && (this.intervalTED.length > this.amountOfElementsToDisplay)
  }

  mounted () {
    this.fetchFacilities()
    window.addEventListener('resize', this.setAmountOfElementsToDisplay)
  }

  destroyed () {
    window.removeEventListener('resize', this.setAmountOfElementsToDisplay)
    this.filters = {
      skip: 0,
      limit: 1000,
      excludeZeroBalances: true,
      sort: 'resident'
    }
    this.submittedFilters = {}
    this.residentModuleInstance.setCollectionTaskWithAgingFilters({})
    this.residentModuleInstance.SET_COLLECTION_WITH_AGING_TASKS([])
    this.residentModuleInstance.SET_COLLECTION_TASKS_WITH_AGING_TOTAL(0)
  }

  async fetchFacilities () {
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    const res = await this.facilityModuleInstance.getFacilityListAndReturn({})
    this.facilityOptions = res.map((facility: IFacility) => {
      return {
        value: facility.id,
        key: facility.name,
        content: facility.name
      }
    })
    this.$eventBus.$emit('loading:disable')
    if (this.facilityOptions && this.facilityOptions.length) {
      this.selectFacility(this.facilityOptions[0])
    }
  }

  selectFacility (event: any) {
    this.selectedFacility = event.value
    this.clearFilters()
    this.getAging()
  }

  setVirtualContainerHeight () {
    this.virtualContainerHeight = window.innerHeight - 420 > 500 ? window.innerHeight - 420 : 500
  }

  setSubRowHover (e: any) {
    if (e.target && e.target.getAttribute('index')) {
      this.clearSubRowHover()
      const elemIndex = e.target.getAttribute('index')
      e.target.closest('.aging-body').classList.add(`hover-${elemIndex}`)
    }
  }

  clearSubRowHover () {
    document.body.querySelectorAll('.aging-body').forEach((item: any) => {
      item.className = item.className.replace(/hover-\d/gm, '')
    })
  }

  showFilterModal (value: string) {
    this.modalComponent = value
    this.submittedFilters = { ...this.filtersMap }
    this.showFilterOptionModal = true
  }

  hideFilterModal () {
    this.showFilterOptionModal = false
  }

  cancelFilterChanges () {
    this.residentModuleInstance.setCollectionTaskWithAgingFilters(this.submittedFilters)
    this.hideFilterModal()
  }

  removeFilter (type: string, key: string | number) {
    const filters = { ...this.filtersMap }
    delete filters[type][key]
    this.residentModuleInstance.setCollectionTaskWithAgingFilters(filters)
    this.getAging()
  }

  submitFilter () {
    this.hideFilterModal()
    this.getAging()
  }

  onScroll (e: MouseEvent) {
    if (e.shiftKey && this.ableToScroll) {
      // @ts-ignore
      this.$refs.timelinebar.onScroll(e)
    }
  }

  calcGrandTotal (task: any) {
    return Object.values(task.payerTypesMap).reduce((sum: number, payer: any) => sum + payer.payerTotal, 0)
  }

  updateShownAgingList (index: number = 0) {
    this.currentFirstItemIndex = index
  }

  @Watch('intervalTED', { deep: true, immediate: true })
  setAmountOfElementsToDisplay () {
    this.$nextTick(() => {
      const $elem: HTMLElement | null = document.getElementById('scrollable-table')
      if (!$elem) {
        return
      }
      const elemWidth = $elem.offsetWidth
      this.amountOfElementsToDisplay = Math.floor((elemWidth) / this.elementWidth)
      this.updateShownAgingList()
    })
  }

  toggleLineItemsModal (value: boolean) {
    this.showLineItemsModal = value
  }

  toggleHistoryModal (value: boolean) {
    this.showHistoryModal = value
  }

  toggleScheduleCallModal (value: boolean) {
    this.showScheduleCallModal = value
  }

  setSelectedResident (resident: string | number) {
    this.selectedResident = resident
  }

  async getTEDLineItems (value: any) {
    this.selectedTED = value
    this.toggleLineItemsModal(true)
  }

  setSortOption (value: string) {
    this.selectedSortOption = value
    this.getAging()
  }

  clearFilters () {
    this.filters = {
      skip: 0,
      limit: 1000,
      facilities: [this.selectedFacility],
      excludeZeroBalances: true,
      sort: this.selectedSortOption
    }
    this.submittedFilters = {}
    this.residentModuleInstance.setCollectionTaskWithAgingFilters({})
    this.getAging()
  }

  setRequestFilters () {
    const filtersMap = { ...this.filtersMap }
    const filters: any = {}
    Object.keys(filtersMap).forEach((key: string) => {
      if (!filters[key]) {
        filters[key] = {}
      }
      if (key === 'excludeZeroBalances') {
        filters[key] = Object.values(filtersMap[key]).map((item: any) => item.value)[0]
        return
      }
      filters[key] = Object.values(filtersMap[key]).map((item: any) => item.value)
    })
    this.filters = {
      ...this.filters,
      ...filters,
      facilities: [this.selectedFacility],
      sort: this.selectedSortOption
    }
  }

  async getAging () {
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    this.clearSubRowHover()
    this.setRequestFilters()
    await this.residentModuleInstance.fetchCollectionTasksWithAgingByFilters(this.filters)
    setTimeout(() => {
      this.$eventBus.$emit('loading:disable')
      this.setVirtualContainerHeight()
    }, 300)
    this.timebarSyncKey += 1
  }
}
